<ng-container *ngIf="businessObject?.categories?.length">
  <ng-container
    *ngIf="breakpointService.isTabletViewObservable | async; else largeScreen"
    [ngTemplateOutlet]="categoryListSmallScreenTemplate"
  ></ng-container>

  <ng-template #largeScreen>
    <ng-container
      [ngTemplateOutlet]="categoryListLargeScreenTemplate"
    ></ng-container>
  </ng-template>
</ng-container>

<ng-template #categoryListLargeScreenTemplate>
  <div class="flex-row-align-start">
    <div class="category-as-button-container">
      <ng-container *ngFor="let category of businessObject.categories">
        <button
          *ngIf="!isCategorySelected(category.id)"
          mat-stroked-button
          color="primary"
          class="height-auto"
          (click)="categoryClickHandler(category)"
        >
          <ng-container
            [ngTemplateOutlet]="categoryNameTemplate"
            [ngTemplateOutletContext]="{ category }"
          ></ng-container>
        </button>
        <button
          *ngIf="isCategorySelected(category.id)"
          mat-flat-button
          color="primary"
          class="height-auto"
          (click)="categoryClickHandler(category)"
        >
          <ng-container
            [ngTemplateOutlet]="categoryNameTemplate"
            [ngTemplateOutletContext]="{ category }"
          ></ng-container>
        </button>

        <lib-spacer [height]="10"></lib-spacer>
      </ng-container>
    </div>

    <div class="selected-category-container">
      <ng-container
        [ngTemplateOutlet]="categoryAsCardTemplate"
        [ngTemplateOutletContext]="{
          category: preSelectedCategoryToDisplayOnWideScreen
        }"
      ></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #categoryListSmallScreenTemplate>
  <mat-accordion [multi]="true">
    <ng-container *ngFor="let category of businessObject.categories">
      <ng-container
        *ngIf="category.products?.length; else categoryWithoutProductTemplate"
        [ngTemplateOutlet]="categoryAsCollapseTemplate"
        [ngTemplateOutletContext]="{ category }"
      ></ng-container>
      <ng-template #categoryWithoutProductTemplate>
        <ng-container
          [ngTemplateOutlet]="categoryAsCardTemplate"
          [ngTemplateOutletContext]="{ category }"
        ></ng-container>
      </ng-template>

      <lib-spacer [height]="40"></lib-spacer>
    </ng-container>
  </mat-accordion>
</ng-template>

<ng-template #categoryAsCollapseTemplate let-category="category">
  <mat-expansion-panel #panel [expanded]="shouldAutoExpandedCategory(category)">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div style="text-align: left">
          <ng-container
            [ngTemplateOutlet]="categoryNameTemplate"
            [ngTemplateOutletContext]="{ category }"
          ></ng-container>

          <ng-container
            *ngIf="panel.expanded"
            [ngTemplateOutlet]="categoryDescriptionTemplate"
            [ngTemplateOutletContext]="{ category }"
          ></ng-container>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <ng-container
      [ngTemplateOutlet]="serviceListTemplate"
      [ngTemplateOutletContext]="{ products: category.products }"
    ></ng-container>
  </mat-expansion-panel>
</ng-template>

<ng-template #categoryAsCardTemplate let-category="category">
  <lib-base-card>
    <div class="card-content">
      <ng-container
        [ngTemplateOutlet]="categoryNameTemplate"
        [ngTemplateOutletContext]="{ category }"
      ></ng-container>

      <ng-container
        [ngTemplateOutlet]="categoryDescriptionTemplate"
        [ngTemplateOutletContext]="{ category }"
      ></ng-container>

      <lib-spacer></lib-spacer>

      <ng-container
        [ngTemplateOutlet]="serviceListTemplate"
        [ngTemplateOutletContext]="{ products: category.products }"
      ></ng-container>
    </div>
  </lib-base-card>
</ng-template>

<ng-template #categoryNameTemplate let-category="category">
  <h3 style="position: relative">
    <strong
      >{{ category.name }}
      <span *ngIf="category.products.length"
        >({{ category.products.length }})</span
      ></strong
    >
    <lib-animated-discount-icon
      *ngIf="shouldDisplayDiscountIconForCategory(category)"
      [size]="1.2"
    ></lib-animated-discount-icon>
  </h3>
</ng-template>

<ng-template #categoryDescriptionTemplate let-category="category">
  <div *ngIf="category.description?.length" class="description-color">
    {{ category.description }}
  </div>
</ng-template>

<ng-template #serviceListTemplate let-products="products">
  <ng-container *ngFor="let product of products">
    <lib-spacer [height]="10"></lib-spacer>
    <lib-divider></lib-divider>
    <lib-spacer [height]="10"></lib-spacer>

    <div
      class="flex-row-space-between"
      [class.highlight-text]="isProductSelected(product.id)"
    >
      <div
        [class.full-width]="breakpointService.isTabletViewObservable | async"
      >
        <div style="text-align: left">
          <div
            class="clickable-container"
            (click)="productClickHandler(product.id)"
          >
            <div style="position: relative">
              {{ product.name }}

              <lib-animated-discount-icon
                *ngIf="isAnyDiscountActivated(product)"
                [size]="1.2"
              ></lib-animated-discount-icon>
            </div>

            <div *ngIf="product.description?.length" class="description-color">
              {{ product.description }}
            </div>
          </div>

          <div class="flex-row-space-between description-color">
            <div>
              <span
                [style.margin-right.px]="
                  (breakpointService.isTabletViewObservable | async) ? 10 : 0
                "
                >{{ product.duration }}
                {{ 'salon-service-selection.text.minutes' | translate }}</span
              >

              <ng-container
                *ngIf="breakpointService.isTabletViewObservable | async"
                [ngTemplateOutlet]="productPriceTemplate"
                [ngTemplateOutletContext]="{ product }"
              ></ng-container>
            </div>

            <ng-container
              *ngIf="breakpointService.isTabletViewObservable | async"
              [ngTemplateOutlet]="selectButtonTemplate"
              [ngTemplateOutletContext]="{ product }"
            ></ng-container>
          </div>
        </div>

        <ng-container
          *ngIf="breakpointService.isTabletViewObservable | async"
          [ngTemplateOutlet]="discountDetailButtonTemplate"
          [ngTemplateOutletContext]="{ product }"
        ></ng-container>
      </div>

      <div
        *ngIf="!(breakpointService.isTabletViewObservable | async)"
        class="flex-row"
      >
        <div class="flex-column-end" style="padding-left: 10px">
          <div>
            <ng-container
              [ngTemplateOutlet]="productPriceTemplate"
              [ngTemplateOutletContext]="{ product }"
            ></ng-container>
          </div>

          <ng-container
            [ngTemplateOutlet]="discountDetailButtonTemplate"
            [ngTemplateOutletContext]="{ product }"
          ></ng-container>
        </div>

        <lib-spacer></lib-spacer>

        <ng-container
          [ngTemplateOutlet]="selectButtonTemplate"
          [ngTemplateOutletContext]="{ product }"
        ></ng-container>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #productPriceTemplate let-product="product">
  <span *ngIf="isAnyDiscountActivated(product)" class="original-price-label"
    >{{ product.price | roundNumberFormatter }}
    {{ businessObject?.currency }}</span
  >
  <span [class.highlight-text]="isAnyDiscountActivated(product)">
    {{
      (isAnyDiscountActivated(product)
        ? getPromotionalPrice(product)
        : product.price
      ) | roundNumberFormatter
    }}
    {{ businessObject?.currency }}
  </span>
</ng-template>

<ng-template #discountDetailButtonTemplate let-product="product">
  <div
    *ngIf="
      shouldDisplayPromotionDetails(product) ||
      shouldDisplayHappyHourDetails(product)
    "
    mat-ripple
    class="clickable-container highlight-text text-under-line"
    (click)="displayDiscountDetails(product)"
  >
    {{ 'salon-service-selection.text.discount-details' | translate }}
  </div>
</ng-template>

<ng-template #selectButtonTemplate let-product="product">
  <div class="select-button-container">
    @if (isProductSelected(product.id)) {
    <button
      mat-flat-button
      color="primary"
      [disabled]="isDisabled || shouldDisableProductSelection(product.id)"
      (click)="productClickHandler(product.id)"
    >
      {{ 'salon-service-selection.buttons.selected' | translate }}
    </button>
    } @else {
    <button
      mat-stroked-button
      color="primary"
      [disabled]="isDisabled || shouldDisableProductSelection(product.id)"
      (click)="productClickHandler(product.id)"
    >
      {{ 'salon-service-selection.buttons.select' | translate }}
    </button>
    }
  </div>
</ng-template>
